module.exports = __webpack_public_path__ + "static/media/draugiem-lv.cb425004.svg";